import type { FormEvent } from 'react'
import { AleloLayout } from '@/components/AleloLayout'
import { AleloStepper } from '@/components/AleloStepper'
import styles from '@/components/AleloLayout.module.css'
import { OtpForm } from '@/screens/mfa-shared/OtpForm'
import type { VerificationChannel } from '@/utils/signupVerificationApi'
import { OTP_COPY } from './useSignupVerification'

type Props = {
  channel: VerificationChannel
  channels: VerificationChannel[]
  /** E-mail ou telefone para o qual o código foi enviado. */
  destination: string
  currentStep: number
  totalSteps: number
  code: string
  onCodeChange: (value: string) => void
  error?: string
  pending: boolean
  onSubmit: (event: FormEvent) => void
  resendSeconds: number
  onResend: () => void
}

/** Sub-etapa de confirmação de um canal, dentro da própria tela de cadastro. */
export function SignupOtpStep({
  channel,
  channels,
  destination,
  currentStep,
  totalSteps,
  code,
  onCodeChange,
  error,
  pending,
  onSubmit,
  resendSeconds,
  onResend,
}: Props) {
  const copy = OTP_COPY[channel]
  return (
    <AleloLayout>
      <AleloStepper currentStep={currentStep} channels={channels} />
      <p className={styles.signupHint}>{`Passo ${currentStep} de ${totalSteps}`}</p>
      <h1 className={styles.title}>{copy.title}</h1>
      <p className={styles.subtitle}>{`${copy.description} ${destination}.`}</p>
      <OtpForm
        code={code}
        onCodeChange={onCodeChange}
        codePlaceholder="Código de 6 dígitos"
        codeMaxLength={6}
        error={error}
        submitLabel={copy.submit}
        pending={pending}
        onSubmit={onSubmit}
        resendLabel="Reenviar código"
        resendSeconds={resendSeconds}
        resendDisabled={resendSeconds > 0}
        onResend={onResend}
      />
    </AleloLayout>
  )
}
